import * as Scrivito from "scrivito";
import { sectionColors } from "^/config/attributeConsts";

const BoxWidget = Scrivito.provideWidgetClass("BoxWidget", {
  attributes: {
    body: "widgetlist",
    boxStyle: [
      "enum",
      {
        values: sectionColors,
      },
    ],
    useOffset: ["enum", { values: ["yes", "no"] }],
    classes: ["multienum", { values: ["ps-5", "py-3", "p-y", "shadow"] }],
  },
  extractTextAttributes: ["body"],
});

export default BoxWidget;
